import { render, staticRenderFns } from "./App2017.vue?vue&type=template&id=7bea2d33&scoped=true&"
import script from "./App2017.vue?vue&type=script&lang=js&"
export * from "./App2017.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea2d33",
  null
  
)

export default component.exports